import { BsThreeDotsVertical } from "react-icons/bs";
import useDebounce from "../../hooks/useDebounce";
import { AiFillHome } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { Suspense } from "react";
import Link from "next/link";

const Dropdown = dynamic(import("../Dropdown"), {
  suspense: true,
});

export interface Categories {
  id: number;
  category: string;
}

interface BarProps {
  categories: Categories[];
}

const Bar: React.FC<BarProps> = ({ categories }) => {
  const router = useRouter();

  const _onSearch = (e: any) => {
    router.push({
      pathname: "/blogs",
      query: { q: `${e.target.value}`, page: 1 },
    });
  };

  const onSearch = useDebounce(_onSearch, 250);

  return (
    <div className="flex w-full text-sm text-black">
      <div className="no-scrollbar flex justify-between gap-5 overflow-x-scroll items-center whitespace-nowrap px-5 md:px-0 py-2 w-full">
        <div>
          <Link  href="/blogs">
            <a className="text-lg">
              <AiFillHome />
            </a>
          </Link>
        </div>

        {categories ? (
          categories.slice(0, 3).map((item, index) => (
            <div key={index} className="transition duration-300 ease-in-out py-1 px-2 hover:bg-secondary-500 rounded-md">
              <Link
                href={`/category/${item.category.split(" ").join("-")}`}
              >
                <a >{item.category}</a>
              </Link>
            </div>
          ))
        ) : (
          <></>
        )}
        <div className="flex md:hidden gap-5">
          <>
            {categories &&
              categories.slice(3, categories.length).map((item, index) => (
                <div key={index}>
                  <Link
                    
                    href={`/category/${item.category.split(" ").join("-")}`}
                  >
                    <a>{item.category}</a>
                  </Link>
                </div>
              ))}
          </>
        </div>
        {categories.length > 3 && (
          <div className="hidden md:flex">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Dropdown
                title={
                  <>
                    <BsThreeDotsVertical />
                  </>
                }
              >
                <div className="flex flex-col gap-2">
                  <>
                    {categories &&
                      categories
                        .slice(3, categories.length)
                        .map((item, index) => (
                          <div
                            className="pt-2 pb-3 px-3 border-b border-slate-300"
                            key={index}
                          >
                            <Link
                              
                              href={`/category/${item.category
                                .split(" ")
                                .join("-")}`}
                            >
                              <a className="text-primary">{item.category}</a>
                            </Link>
                          </div>
                        ))}
                  </>
                </div>
              </Dropdown>
            </Suspense>
          </div>
        )}
      </div>
      <div className="items-center justify-end w-1/3 hidden lg:flex">
        <div className="bg-white py-1 w-4/5 rounded-md justify-between shadow flex items-center text-black">
          <input
            onChange={onSearch}
            type="text"
            placeholder="Search blogs"
            className="px-2 outline-none border-none w-full text-black"
          />
          <button className="pr-2 text-primary" type="submit">
            <FaSearch />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Bar;
